export function getCompanyIDfromUrl() {
  const url = window.location.href;
  const regex = /company\/(\d+)\//;
  const match = url.match(regex);
  if (match) {
    const companyId = match[1];
    return companyId
  }
}
